// extracted by mini-css-extract-plugin
export default {"background":"status_background__E-HE9","success":"status_success__TjEnd","error":"status_error__rZwuv","neutral":"status_neutral__rwImU"};